<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <router-link to="/addvalidationTask" class=" btn btn-success transition border-0 lh-1 fw-medium">
                + Ajouter une validation Task </router-link>
            <div class="d-flex align-items-center">

                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher une validation tasks" />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                             <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Référence  de la Tache
                            </th> -->
                             <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Référence  Besc
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Status
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Priority
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date & heure traitement Tache
                            </th>
                            <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date & heure traitement Tache par Agent
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date et heure de clôture de la tâche
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date et heure de correction de la tache
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date et heure de la dernière action
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date et heure d’expiration
                            </th> -->
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Validation Queue
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Utilisateur
                            </th>
                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                                Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(validationTask, index) in validationTasks" :key="index">
                            <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                               {{ validationTask?.reftask || 'Aucune Ref disponible' }}
                            </td> -->
                             <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                               {{ validationTask.besc?.refbesc || 'Aucun Besc disponible' }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getStatusBadgeClass(validationTask?.status)"></span>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getPriorityDisplay(validationTask?.priority)"></span>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(validationTask.sla_due_at) }}
                            </td>
                            <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(validationTask.started_at) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(validationTask.completed_at) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(validationTask.returned_at) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(validationTask.last_action_at) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(validationTask.lock_expires_at) }}
                            </td> -->
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationTask.validationqueue?.name }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationTask.user?.nom  || 'Aucun utilisateur affecté pour le moment' }} {{ validationTask.user?.prenom }}
                            </td>

                            <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                                <div class="dropdown">
                                    <span class="badge text-white bg-primary fs-15 dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Actions
                                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                                    </span>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <router-link
                                                :to="{ name: 'EditValidationTaskPage', params: { id: validationTask.id } }"
                                                class="dropdown-item d-flex align-items-center"><i
                                                    class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier</router-link>
                                        </li>
                                        <li>
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);"
                                                @click="suppression(validationTask.id, validationTask, 'validationt', 'validationTask')">
                                                <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                                                Supprimer
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">

                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
                    @paginate="handlePaginate" />

            </div>
        </div>
    </div>

</template>
<script lang="ts">

import { defineComponent, onMounted, ref, watch, computed } from "vue";

import ApiService from "../../services/ApiService";
import { format_date, suppression, error } from "../../utils/utils";
import axios from 'axios';
import Swal from "sweetalert2";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import { TypeFretPaiement } from "@/models/TypeFretPaiement";
import AddModalValidationTask from "./AddModalValidationTask.vue";
import { ValidationTask } from "@/models/ValidationTask";
import { formatDate } from "@fullcalendar/core";

export default defineComponent({
    name: "ListeValidationTask",
    components: {
        PaginationComponent
    },
    setup: () => {
        // const modules = {

        // };

        const validationTasks = ref<Array<ValidationTask>>([]);
        const validationTask = ref<ValidationTask>();
        const addModalValidationTaskRef = ref<null | HTMLElement>(null);
        const selectedItem = ref(0);
        const format = (d) => d ? formatDate(d) : "";

        // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
            try {
                page.value = page_;
                getAllValidationTask(page_, limit_);
            } catch (error) {
                //
            }
        };

        function rechercher() {
            getAllValidationTask(page.value, limit.value, searchTerm.value);
        }

        // END PAGINATE

        function getAllValidationTask(page = 1, limi = 10, searchTerm = '') {
            // const user = JwtService.getUser();
            // console.log("user:", user);
            // if (!user) return error("Utilisateur non connecté");
            // const userId = user.userId.replace(/\/+$/, '').trim();
            // if (!userId) return error("Utilisateur non connecté");
            return ApiService.get(`validationts?page=${page}&limit=${limi}&searchTerm=${searchTerm}&`)
                .then(({ data }) => {
                    validationTasks.value = data.data.data;
                    console.log("azerty", validationTasks.value);
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                })
                .catch(({ response }) => {
                    error(response.data.message)
                });
        }
        const getStatusBadgeClass = (value: string | null | undefined): string => {
            if (!value) {
                return '<span class="badge bg-secondary">Inconnu</span>';
            }
            switch (value) {
                case 'PENDING':
                    return '<span class="badge bg-primary text-white">En attente</span>';

                case 'IN_PROGRESS':
                    return '<span class="badge bg-info text-white">En cours</span>';

                case 'COMPLETED':
                    return '<span class="badge bg-success text-white">Terminée</span>';

                case 'RETURNED_FOR_CORRECTION':
                    return '<span class="badge bg-orange text-white">Retour correction</span>';

                case 'CANCELLED':
                    return '<span class="badge bg-danger text-white">Annulée</span>';

                default:
                    return `<span class="badge bg-light text-dark">${value}</span>`;
            }
        };

        const getPriorityDisplay = (value: string | null | undefined): string => {
            if (!value) {
                return '<span class="badge bg-secondary"><i class="flaticon-cancel me-1"></i> Aucun</span>';
            }

            switch (value) {
                case 'LOW':
                    return '<span class="badge bg-success text-white"> Faible</span>';

                case 'NORMAL':
                    return '<span class="badge bg-info text-white"> Normale</span>';

                case 'HIGH':
                    return '<span class="badge bg-warning text-dark">Élevée</span>';

                case 'CRITICAL':
                    return '<span class="badge bg-danger text-white"> Critique</span>';

                default:
                    return `<span class="badge bg-secondary text-white"> ${value}</span>`;
            }
        };

        onMounted(() => {
            getAllValidationTask();
        });

        function moddifier(EditValidationTask: ValidationTask) {
            validationTask.value = EditValidationTask;
            selectedItem.value = EditValidationTask.id;
        }
        const recharger = () => {
            getAllValidationTask();
        };

        const privileges = ref<Array<string>>(JwtService.getPrivilege());

        const checkPermission = (name) => {
            return privileges.value.includes(name);
        }
        return {
            // modules,
            format,
            checkPermission,
            selectedItem,
            validationTasks,
            recharger,
            suppression,
            moddifier,
            page,
            totalPages,
            limit,
            totalElements,
            getAllValidationTask,
            handlePaginate,
            searchTerm,
            rechercher, getStatusBadgeClass,
            getPriorityDisplay
        };
    },
});
</script>
